module.exports = __webpack_public_path__ + "img/articulos2.a1fb84c1.png";